import { IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
import RestoreFromTrashIcon from '@mui/icons-material/RestoreFromTrash';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Tooltip from '@mui/material/Tooltip';
import Zoom from '@mui/material/Zoom';
import {Dispatch, SetStateAction, useState} from 'react';
import { Customer } from '../../model/Customer';
import { SaveEditCustomerModal } from '../modal/SaveEditCustomerModal';
import { CustomerRequestDTO } from '../../model/CustomerRequestDTO';
import { Meal } from '../../model/Meal';
import { Entities } from '../util/Entities';
import { MealsToCustomerTransferModal } from '../modal/MealsToCustomerTransferModal';
import { isMobile } from 'react-device-detect';
import { Dropdown, MenuProps } from 'antd';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { DeleteRestoreDialog } from '../util/DeleteRestoreDialog';
import { HardDeleteDialog } from '../util/HardDeleteDialog';
import {OwnAccountComponent} from "./OwnAccountComponent";

export const CustomerElement : React.FC<{customer : Customer, 
    show : boolean, setShow : Dispatch<SetStateAction<boolean>>, index : number,
    lengthOfCustomersList : number,
    handleSaveToDatabase : (customerRequestDTO: CustomerRequestDTO) => Promise<() => void>,
    handleHardDelete : (id: number) => Promise<() => void>,
    handleDeleteOrRestore : (id: number, isDelete : boolean) => Promise<() => void>,
    mealList : Meal[],
    page : number
    isListLimitActive : boolean
    isListLimitInactive : boolean
}> = (props) => {

    const {customer, index, lengthOfCustomersList,
        handleSaveToDatabase, handleDeleteOrRestore, handleHardDelete, mealList, page,
        isListLimitActive, isListLimitInactive} = props
    const [show, setShow] = useState(false);
    const [showTransfer, setShowTransfer] = useState<boolean>(false)
    const [showHardDeleteDialog, setShowHardDeleteDialog] = useState<boolean>(false)
    const [showDeleteRestoreDialog, setShowDeleteRestoreDialog] = useState<boolean[]>([false,false]);
    const items: MenuProps['items'] = [
      {
        label: (
          <IconButton onClick={() => setShow(true)}>
            <EditIcon />
          </IconButton>
        ),
        key: '0',
      },
      {
        label: (
          <IconButton onClick={() => {setShowTransfer(true)}} disabled={customer.active === false}>
            <LibraryAddIcon />
          </IconButton>
        ),
        key: '1',
      },
      {
        label: (
          <IconButton color={`warning`} disabled ={(customer.active === true && isListLimitInactive) || (customer.active === false && isListLimitActive)} onClick={() => {setShowDeleteRestoreDialog([true, customer.active === true])}}>
            {customer.active === true ? <DeleteIcon /> : <RestoreFromTrashIcon/>}
          </IconButton>
        ),
        key: '2',
      },
      {
        label: (
          <IconButton color={`error`} onClick={() => {setShowHardDeleteDialog(true)}}>
            <DeleteIcon />
          </IconButton>
        ),
        key: '3',
      },
    ];
    
    return (
        <tr className={isMobile ? 'mobile-text-size align-middle' : 'align-middle'} key={index}>
              {isMobile ? <></> : <td>{index+1+(page-1)*10}</td>}
              <td>{customer.position}</td>
              <td>{customer.firstName}</td>
              <td>
                {`${customer.lastName} `}
                {customer.active ? 
                    ""
                    :
                    <Tooltip title="Ten rodzic został wcześniej usunięty. Na tej stronie będzie widoczny tylko do końca bieżącego miesiąca" 
                        arrow placement="right">
                        <ErrorOutlineIcon fontSize="small" sx={{ color: 'orange' }}/>
                    </Tooltip>
                }
              </td>
              {isMobile ?
              <></>
              :
              <>
              <td>{customer.childName}</td>
              <td>{customer.email}</td>
              <td className={'small-description'}>{customer.description}</td>
              </>
              }
              <OwnAccountComponent customer={customer}/>
              {isMobile ?
              <td>
                <Dropdown menu={{ items }} trigger={['click']}>
                  <MoreVertIcon />
                </Dropdown>
              </td>
              :
              <td>
                <Tooltip TransitionComponent={Zoom} title="Edytuj dane rodzica">
                    <IconButton onClick={() => setShow(true)}>
                      <EditIcon />
                    </IconButton>
                  </Tooltip>
                  <>
                    <IconButton onClick={() => {setShowTransfer(true)}} disabled={customer.active === false}>
                        <Tooltip TransitionComponent={Zoom} title="Przypisz posiłki">
                            <LibraryAddIcon />
                        </Tooltip>
                    </IconButton>
                  </>
                  <>
                  <IconButton color={`warning`} disabled ={(customer.active === true && isListLimitInactive) || (customer.active === false && isListLimitActive)} onClick={() => {setShowDeleteRestoreDialog([true, customer.active === true])}}>
                      <Tooltip TransitionComponent={Zoom} title={`${customer.active === true ? `Usuń` : `Odtwórz`} rodzica`}>
                        {customer.active === true ? <DeleteIcon /> : <RestoreFromTrashIcon/>}
                      </Tooltip>
                  </IconButton>
                  </>
                  <>
                  <IconButton color={`error`} onClick={() => {setShowHardDeleteDialog(true)}}>
                      <Tooltip TransitionComponent={Zoom} title={`Usuń trwale rodzica`}>
                        <DeleteIcon />
                      </Tooltip>
                  </IconButton>
                  </>
              </td>
              }
              <>
                <SaveEditCustomerModal customer={customer} show={show} setShow={setShow} index={index}
                                       lengthOfCustomersList={lengthOfCustomersList}
                                       handleSaveToDatabase={handleSaveToDatabase} mealList={mealList}/>
                <MealsToCustomerTransferModal customer={customer} mealList={mealList} index={index} showTransfer={showTransfer} setShowTransfer={setShowTransfer}/> 
                <DeleteRestoreDialog idToDelete={customer.customerid!} showDeleteRestoreDialog={showDeleteRestoreDialog} setShowDeleteRestoreDialog={setShowDeleteRestoreDialog} handleDeleteOrRestore={handleDeleteOrRestore} entity={Entities.CUSTOMER}/>
                <HardDeleteDialog idToDelete={customer.customerid!} showHardDeleteDialog={showHardDeleteDialog} setShowHardDeleteDialog={setShowHardDeleteDialog} handleHardDelete={handleHardDelete} entity={Entities.CUSTOMER}/>
              </>
        </tr>
    )
}